import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7243b5a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__card-top" }
const _hoisted_2 = { class: "h5 product__card-name" }
const _hoisted_3 = { class: "fz-smaller product__card-model" }
const _hoisted_4 = {
  key: 0,
  class: "product__card-comparison tooltip__info"
}
const _hoisted_5 = { class: "checkbox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "sprite-icon comparison__icon",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#compare" })
  ])
], -1))
const _hoisted_7 = { class: "product__card-overlay" }
const _hoisted_8 = {
  key: 0,
  class: "swiper-container slider__gallery product__card-slider"
}
const _hoisted_9 = { class: "swiper-wrapper" }
const _hoisted_10 = { class: "swiper-slide dflex" }
const _hoisted_11 = ["data-src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-lazy-preloader" }, null, -1))
const _hoisted_13 = ["href", "onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon add-favorite__icon",
  width: "16",
  height: "14"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#heart-fill" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "mark__text" }
const _hoisted_17 = { class: "product__card-bottom" }
const _hoisted_18 = { class: "product__card-price" }
const _hoisted_19 = { class: "price" }
const _hoisted_20 = { class: "h4" }
const _hoisted_21 = { class: "price__bottom" }
const _hoisted_22 = { class: "price__bottom-text" }
const _hoisted_23 = {
  key: 1,
  class: "price price__discount"
}
const _hoisted_24 = { class: "h4" }
const _hoisted_25 = { class: "price__mark" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "price__mark-bg",
  src: "/img/red-mark.png",
  alt: ""
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price__mark--minus" }, "-", -1))
const _hoisted_28 = {
  key: 2,
  class: "price__bottom"
}
const _hoisted_29 = { class: "price__bottom-text" }
const _hoisted_30 = {
  key: 3,
  class: "special-offer"
}
const _hoisted_31 = { class: "product__card-features" }
const _hoisted_32 = { class: "features__list" }
const _hoisted_33 = {
  key: 0,
  class: "features__list-label tooltip__info"
}
const _hoisted_34 = { class: "features__list-text" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "KM", -1))
const _hoisted_36 = { class: "product__card-stock" }
const _hoisted_37 = { class: "product__card-top" }
const _hoisted_38 = { class: "h5 product__card-name" }
const _hoisted_39 = { class: "fz-smaller product__card-model" }
const _hoisted_40 = {
  key: 0,
  class: "product__card-comparison tooltip__info"
}
const _hoisted_41 = { class: "checkbox" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "sprite-icon comparison__icon",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#compare" })
  ])
], -1))
const _hoisted_43 = { class: "product__card-overlay" }
const _hoisted_44 = ["href", "onClick"]
const _hoisted_45 = { class: "mark__text" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon add-favorite__icon",
  width: "16",
  height: "14"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#heart-fill" })
], -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "product__card-bottom" }
const _hoisted_50 = {
  key: 0,
  class: "product__card-price"
}
const _hoisted_51 = { class: "price" }
const _hoisted_52 = { class: "h4" }
const _hoisted_53 = { class: "price__bottom" }
const _hoisted_54 = { class: "price__bottom-text" }
const _hoisted_55 = {
  key: 0,
  class: "price price__discount"
}
const _hoisted_56 = { class: "h4" }
const _hoisted_57 = { class: "price__mark" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "price__mark-bg",
  src: "/img/red-mark.png",
  alt: ""
}, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price__mark--minus" }, "-", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price__mark--percent" }, "%", -1))
const _hoisted_61 = {
  key: 1,
  class: "price__bottom"
}
const _hoisted_62 = { class: "price__bottom-text" }
const _hoisted_63 = { class: "product__card-features" }
const _hoisted_64 = { class: "features__list" }
const _hoisted_65 = {
  key: 0,
  class: "features__list-label tooltip__info"
}
const _hoisted_66 = { class: "features__list-text" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "KM", -1))
const _hoisted_68 = { class: "product__card-stock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _component_app_vehicle_options = _resolveComponent("app-vehicle-options")!
  const _directive_tippy = _resolveDirective("tippy")!
  const _directive_app_gallery = _resolveDirective("app-gallery")!
  const _directive_app_auth_required = _resolveDirective("app-auth-required")!

  return (_ctx.isApproved)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        class: "product__card c-product_card"
      }, _ctx.$attrs), [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.vehicleTileDto.brand?.name + " " + _ctx.vehicleTileDto.model + " " + _ctx.vehicleTileDto.finish), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.vehicleTileDto.motorisation), 1),
          false
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isSelectedForComparison) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.isSelectedForComparison]
                    ]),
                    _hoisted_6
                  ])
                ])
              ])), [
                [_directive_tippy, {
                    content: _ctx.i18n.t('carCard.addForComparasion'),
                    interactive: true,
                }]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["product__card-picture", { 'arrow-hover': _ctx.arrowHover }])
        }, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.vehicleTileDto.thumbnail_image)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        class: "swiper-lazy",
                        "data-src": _ctx.vehicleTileDto.thumbnail_image.href_small,
                        style: {
                                    objectFit: 'cover',
                                    'background-color': '#f4f8fd',
                                }
                      }, null, 8, _hoisted_11),
                      _hoisted_12
                    ])
                  ])
                ])), [
                  [_directive_app_gallery]
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: {
                        path: `/auth/vehicle-details/${_ctx.vehicleTileDto.id}`,
                        query: {
                            ..._ctx.filters,
                        },
                    },
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: href,
                  class: "button button--outline",
                  onClick: _withModifiers(
                            () =>
                                _ctx.routeToCarDetails(
                                    navigate,
                                    true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                                )
                        , ["prevent"])
                }, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.viewDetails" })
                ], 8, _hoisted_13)), [
                  [_directive_app_auth_required, {
                            role: 'dealer',
                            showLogin: !_ctx.isAuthenticated,
                            disable: true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                        }]
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_ctx.isApproved)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["add-favorite", { active: _ctx.vehicleTileDto.is_favorite }]),
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFavorite && _ctx.toggleFavorite(...args)))
              }, _hoisted_15, 2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionDtos, (promotion) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "product__card-mark",
              key: promotion
            }, [
              _createElementVNode("div", {
                class: "mark__icon",
                style: _normalizeStyle({
                        backgroundImage: `url(/img/our-cars/${_ctx.iconNameForPromotion(
                            promotion,
                        )}.svg)`,
                    })
              }, null, 4),
              _createElementVNode("span", _hoisted_16, _toDisplayString(promotion?.name), 1)
            ]))
          }), 128))
        ], 2),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (!_ctx.vehicleTileDto?.price_previous)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, [
                      _createVNode(_component_app_format_currency, {
                        value: _ctx.vehicleTileDto?.price_current?.list_price_euro,
                        currency: _ctx.currency
                      }, null, 8, ["value", "currency"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.vehicleTileDto?.price_previous?.list_price_euro > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("p", _hoisted_24, [
                    _createVNode(_component_app_format_currency, {
                      value: _ctx.vehicleTileDto?.price_current?.list_price_euro,
                      currency: _ctx.currency
                    }, null, 8, ["value", "currency"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _hoisted_27,
                    _createVNode(_component_app_format_currency, {
                      value: 
                                _ctx.vehicleTileDto.price_previous?.list_price_euro -
                                _ctx.vehicleTileDto?.price_current?.list_price_euro
                            ,
                      options: {
                                maximumFractionDigits: 0,
                            },
                      currency: "EUR"
                    }, null, 8, ["value"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.vehicleTileDto?.price_previous?.list_price_euro > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["fz-smaller price__bottom-num", {
                            'line-through':
                                _ctx.vehicleTileDto?.price_previous?.list_price_euro >= 0,
                        }])
                  }, [
                    _createVNode(_component_app_format_currency, {
                      value: _ctx.vehicleTileDto?.price_previous?.list_price_euro,
                      currency: _ctx.currency
                    }, null, 8, ["value", "currency"])
                  ], 2),
                  _createElementVNode("span", _hoisted_29, [
                    _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.vehicleTileDto.has_deal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.specialOffer" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_ctx.vehicleTileDto.mileage)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("p", _hoisted_34, [
                      _createTextVNode(_toDisplayString(_ctx.vehicleTileDto.mileage) + " ", 1),
                      _hoisted_35
                    ])
                  ])), [
                    [_directive_tippy, {
                                content: _ctx.i18n.t('carCard.kmUsed'),
                                interactive: true,
                            }]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_app_vehicle_options, {
                "vehicle-id": _ctx.vehicleTileDto.id,
                "show-label": false,
                size: 6
              }, null, 8, ["vehicle-id"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["stock__color purple tooltip__info", [`--${_ctx.vehicleTileDto.color?.name}`]]),
              style: _normalizeStyle({
                        backgroundColor: _ctx.vehicleTileDto.color?.hex,
                        color: _ctx.vehicleTileDto.color?.is_light ? 'black' : 'white',
                    })
            }, null, 6), [
              [_directive_tippy, {
                        content: _ctx.vehicleTileDto.color?.name,
                        interactive: true,
                    }]
            ])
          ])
        ])
      ], 16))
    : (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 1,
        class: "product__card not-login"
      }, _ctx.$attrs), [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("h5", _hoisted_38, _toDisplayString(_ctx.vehicleTileDto.brand?.name + " " + _ctx.vehicleTileDto.model + " " + _ctx.vehicleTileDto.finish), 1),
          _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.vehicleTileDto.motorisation), 1),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isSelectedForComparison) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.isSelectedForComparison]
                    ]),
                    _hoisted_42
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["product__card-picture", { 'arrow-hover': _ctx.arrowHover }])
        }, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_router_link, {
              to: {
                        path: `/auth/vehicle-details/${_ctx.vehicleTileDto.id}`,
                        query: {
                            ..._ctx.filters,
                        },
                    },
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: href,
                  class: "button button--outline",
                  onClick: _withModifiers(
                            () =>
                                _ctx.routeToCarDetails(
                                    navigate,
                                    true /* vehicleDto.label === carLabel.specialDeal, */,
                                )
                        , ["prevent"])
                }, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.viewDetails" })
                ], 8, _hoisted_44)), [
                  [_directive_app_auth_required, {
                            role: 'dealer',
                            showLogin: !_ctx.isAuthenticated,
                            disable: true /* TODO: vehicleDto.label === carLabel.specialDeal, */,
                        }]
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionDtos, (promotion) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "product__card-mark",
              key: promotion
            }, [
              _createElementVNode("div", {
                class: "mark__icon",
                style: _normalizeStyle({
                        backgroundImage: `url(/img/our-cars/${_ctx.iconNameForPromotion(
                            promotion,
                        )}.svg)`,
                    })
              }, null, 4),
              _createElementVNode("span", _hoisted_45, _toDisplayString(promotion?.name), 1)
            ]))
          }), 128)),
          (_ctx.isApproved)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["add-favorite", { active: _ctx.vehicleTileDto.is_favorite }]),
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFavorite && _ctx.toggleFavorite(...args)))
              }, _hoisted_47, 2))
            : _createCommentVNode("", true),
          (_ctx.vehicleTileDto.thumbnail_image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "product__image",
                src: _ctx.vehicleTileDto.thumbnail_image.href_small,
                style: { 'background-color': '#f4f8fd' }
              }, null, 8, _hoisted_48))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_49, [
          (_ctx.vehicleTileDto.pricing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("template", null, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("p", _hoisted_52, [
                      _createVNode(_component_app_format_currency, {
                        value: _ctx.vehicleTileDto.pricing.list_price_euro,
                        currency: _ctx.currency
                      }, null, 8, ["value", "currency"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, [
                      _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                    ])
                  ])
                ]),
                (_ctx.vehicleTileDto.pricing.discount_euro > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("p", _hoisted_56, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.vehicleTileDto.pricing.discount_euro,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _hoisted_59,
                        _createElementVNode("span", null, _toDisplayString(_ctx.vehicleTileDto.pricing.discount_percentage), 1),
                        _hoisted_60
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.vehicleTileDto.pricing.discount_euro > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fz-smaller price__bottom-num", {
                            'line-through': _ctx.vehicleTileDto.pricing.list_price_euro,
                        }])
                      }, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.vehicleTileDto.pricing.price_after_discount_euro,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ], 2),
                      _createElementVNode("span", _hoisted_62, [
                        _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              (_ctx.vehicleTileDto.mileage)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("p", _hoisted_66, [
                      _createTextVNode(_toDisplayString(_ctx.vehicleTileDto.mileage) + " ", 1),
                      _hoisted_67
                    ])
                  ])), [
                    [_directive_tippy, {
                                content: _ctx.i18n.t('carCard.kmUsed'),
                                interactive: true,
                            }]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_app_vehicle_options, {
                "vehicle-id": _ctx.vehicleTileDto.id,
                "show-label": false,
                size: 6
              }, null, 8, ["vehicle-id"])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["stock__color purple tooltip__info", [`--${_ctx.vehicleTileDto.color?.name}`]]),
              style: _normalizeStyle({
                        backgroundColor: _ctx.vehicleTileDto.color?.hex,
                        color: _ctx.vehicleTileDto.color?.is_light ? 'black' : 'white',
                    })
            }, [
              _createTextVNode(_toDisplayString(1))
            ], 6)), [
              [_directive_tippy, {
                        content: _ctx.vehicleTileDto.color?.name,
                        interactive: true,
                    }]
            ])
          ])
        ])
      ], 16))
}